<div class="center" style="position: relative">
  <ngx-file-drop (onFileDrop)="dropped($event);"
    accept="image/png, application/pdf, image/jpeg, image/jpg, image/heic, image/heif"
    contentClassName="file-drop-zone"
    dropZoneClassName="file-drop-zone" dropZoneLabel="Solte o arquivo aqui">
    <ng-template let-openFileSelector="openFileSelector" ngx-file-drop-content-tmp>
      @if (filesInFlight === 0) {
        @if (typeButton === 'SECONDARY') {
          <button (click)="openFileSelector(); $event.preventDefault()" [disabled]="filesInFlight> 0"
            [class.w-full]="width100"
            color="accent" mat-raised-button type="button">
            @if (iconButton) {
              <mat-icon matTooltip="Icone">{{ iconButton }}</mat-icon>
            }
            <span [innerHTML]="titleButton"></span>
          </button>
        }
        @if (typeButton === 'PRIMARY') {
          <button (click)="openFileSelector(); $event.preventDefault()" [disabled]="filesInFlight> 0"
            class="w-full"
            mat-flat-button color="primary" type="button">
            @if (iconButton) {
              <mat-icon matTooltip="Icone">{{ iconButton }}</mat-icon>
            }
            <span [innerHTML]="titleButton"></span>
          </button>
        }
      } @else {
        <button [disabled]="true" [class.w-full]="width100" color="accent" mat-raised-button type="button">
          <mat-icon>
            <mat-spinner [diameter]="18" color="accent"></mat-spinner>
          </mat-icon>
        </button>
      }
      @if (showRemoveButton) {
        <button (click)="removeFile();$event.stopPropagation();" color="primary"
          mat-icon-button
          type="button">
          <mat-icon matTooltip="Remover arquivo">close</mat-icon>
        </button>
      }
    </ng-template>
  </ngx-file-drop>
</div>
